import { definePreset, palette } from '@primeng/themes';
import Material from '@primeng/themes/material';

const PThemePreset = definePreset(Material, {
  semantic: {
    primary: palette('{sky}'),
    colorScheme: {
      light: {
        primary: {
          color: '{sky.800}',
          inverseColor: '#FFFFFF',
          hoverColor: '{sky.600}',
          activeColor: '{sky.500}',
        },
        highlight: {
          background: '{sky.800}',
          focusBackground: '{sky.500}',
          color: '#FFFFFF',
          focusColor: '#FFFFFF',
        },
      },
      dark: {
        primary: {
          color: '{sky.50}',
          inverseColor: '{sky.950}',
          hoverColor: '{sky.100}',
          activeColor: '{sky.200}',
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          sm: {
            padding: {
              x: '0.375rem',
              y: '0.375rem',
            }
          }
        }
      }
    },
    datatable: {
      colorScheme: {
        light: {
          body: {
            cell: {
              padding: '0.375rem 0.5rem',
            },
          },
          header: {
            cell: {
              background: '#f7f7f7'
            }
          }
        },
        dark: {
          header: {
            cell: {
              background: '#27272a'
            }
          }
        }
      },
    },
    floatlabel: {
      colorScheme: {
        light: {
          font: {
            weight: 400,
          },
          color: '#6C8393',
          focus: {
            color: '#6C8393',
          },
        },
      },
    },
    inputtext: {
      colorScheme: {
        light: {
          filled: {
            background: '#FFFFFF',
            hover: {
              background: '#F4FAFE',
            },
            focus: {
              background: '#F4FAFE',
            },
          },
          border: {
            color: '#ACC4D4',
          },
          hover: {
            border: {
              color: '#6C8393',
            },
          },
          focus: {
            border: {
              color: '#6C8393',
            },
          },
          disabled: {
            background: '#F2F2F2',
            color: '#999999',
          },
          invalid: {
            border: {
              color: '#D50005',
            },
          },
          padding: {
            x: '0.5rem',
            y: '0.5rem',
          },
        },
      },
    },
    multiselect: {
      colorScheme: {
        light: {
          option: {
            selected: {
              background: 'rgba(30, 117, 183, 0.12)',
              color: 'rgb(30, 117, 183)',
              focus: {
                background: 'rgba(30, 117, 183, 0.12)',
                color: 'rgb(30, 117, 183)',
              },
            },
          },
          padding: {
            x: '0.5rem',
            y: '0.5rem'
          }
        },
      },
    },
    select: {
      colorScheme: {
        light: {
          disabled: {
            background: '#F2F2F2',
          },
          option: {
            selected: {
              background: 'rgba(30, 117, 183, 0.12)',
              color: 'rgb(30, 117, 183)',
              focus: {
                background: 'rgba(30, 117, 183, 0.12)',
                color: 'rgb(30, 117, 183)',
              },
            },
          },
          padding: {
            x: '0.5rem',
            y: '0.5rem'
          }
        },
      },
    },
    textarea: {
      colorScheme: {
        light: {
          padding: {
            x: '0.5rem',
            y: '0.5rem'
          }
        }
      }
    }
  },
});

export default PThemePreset;
